import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_CONFIG } from '../config/api';
import type { PublicMenu } from '../types/menuDigital';

// Separate API instance for public menu endpoints (no auth token) — mismo
// patrón que autofacturaApi: la página del comensal no tiene sesión.
export const publicMenuApi = createApi({
  reducerPath: 'publicMenuApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_CONFIG.baseUrl,
  }),
  endpoints: (builder) => ({
    getPublicMenu: builder.query<PublicMenu, string>({
      query: (slug) => `/public/menu/${encodeURIComponent(slug)}`,
    }),
    getPublicDailyMenu: builder.query<PublicMenu, string>({
      query: (slug) => `/public/menu/${encodeURIComponent(slug)}/hoy`,
    }),
  }),
});

export const { useGetPublicMenuQuery, useGetPublicDailyMenuQuery } = publicMenuApi;
